// intro-app/account/activate.js

(function () {
    'use strict';
    var controllerId = 'activate';
    angular.module('intro-app').controller(controllerId, ['datacontext', '$translate', activateFn]);

    function activateFn(datacontext, $translate) {
        var vm = this;
        vm.error = null;
        vm.sucess = false;        
        activate();    

        vm.lingua = $translate.use();

        function activate() {
            vm.error = null;

            const urlParams = new URLSearchParams(window.location.search);
            vm.item = {
                "Username": urlParams.get('username') || urlParams.get('Username') || urlParams.get('USERNAME'),
                "UID": urlParams.get('uid') || urlParams.get('Uid') || urlParams.get('UID')
            };            

            return datacontext.account_activate(vm.item).then(function (response) {
                if (response.status == 200) {
                    vm.success = true;
                }
                else {
                    vm.error = response.data;
                }
            });
        }
    }
})();